import {useTheme, SvgIcon, type SvgIconProps, darken} from '@mui/material';

const Folder = (props : SvgIconProps) => {
  const theme = useTheme();
  const color : string = theme?.palette?.[props.color]?.main;
  const tabColor = color
    ? darken(color, 0.12)
    : 'currentColor';

  return (
    <SvgIcon {...props}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20.2619 2H15.5282C14.5677 2 13.7891 2.86306 13.7891 3.92769V4.5H22L22.001 3.92769C22.001 2.86306 21.2224 2 20.2619 2Z" fill={tabColor} />
        <path d="M3.73913 4.48242H22V20.0726C22 20.5838 21.8168 21.0742 21.4906 21.4357C21.1645 21.7972 20.7221 22.0003 20.2609 22.0003H3.73913C3.27788 22.0003 2.83553 21.7972 2.50938 21.4357C2.18323 21.0742 2 20.5838 2 20.0726V6.41011C2 5.89885 2.18323 5.40854 2.50938 5.04703C2.83553 4.68552 3.27788 4.48242 3.73913 4.48242Z" fill="currentColor" />
      </svg>
    </SvgIcon>
  );
}

export default Folder;